import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "v1-other-amount" }
const _hoisted_2 = { class: "v1-other-amount__amount" }
const _hoisted_3 = { class: "v1-other-amount__symbol" }
const _hoisted_4 = {
  class: "v1-other-amount__value",
  "data-testid": "v1-other-amount-value"
}
const _hoisted_5 = {
  key: 0,
  class: "v1-other-amount__min",
  "data-testid": "v1-other-amount-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageLoading = _resolveComponent("PageLoading")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_V1AmountChip = _resolveComponent("V1AmountChip")!
  const _component_V1NumericKeypad = _resolveComponent("V1NumericKeypad")!
  const _component_V1ScreenScaffold = _resolveComponent("V1ScreenScaffold")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_PageLoading, { key: 0 }))
    : (_ctx.error)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, { key: 1 }))
      : (_openBlock(), _createBlock(_component_V1ScreenScaffold, {
          key: 2,
          title: _ctx.t('superpacman-other-amount-title'),
          "title-align": "center",
          "next-disabled": !_ctx.isValid,
          "data-testid": "v1-other-amount",
          onNext: _ctx.handleContinue
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.currencySymbol), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.displayAmount), 1)
              ]),
              (_ctx.allowsCustomAmount && _ctx.minDisplay)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.t("superpacman-minimum-amount")) + " " + _toDisplayString(_ctx.minDisplay), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: _normalizeClass(["v1-other-amount__badge", { 'v1-other-amount__badge--hidden': !_ctx.nextPaymentMessage }]),
                "data-testid": "v1-other-amount-next-payment"
              }, _toDisplayString(_ctx.nextPaymentMessage || ""), 3),
              _createElementVNode("div", {
                class: _normalizeClass(["v1-other-amount__chips", _ctx.allowsCustomAmount ? 'v1-other-amount__chips--scroll' : 'v1-other-amount__chips--grid']),
                "data-testid": "v1-other-amount-chips"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chips, (chip) => {
                  return (_openBlock(), _createBlock(_component_V1AmountChip, {
                    key: `${chip.days}-${chip.amount.value}`,
                    label: chip.term,
                    selected: _ctx.selectedDays === chip.days,
                    "data-testid": `v1-other-amount-chip-${chip.days}`,
                    onSelect: ($event: any) => (_ctx.selectChip(chip))
                  }, null, 8, ["label", "selected", "data-testid", "onSelect"]))
                }), 128))
              ], 2),
              (_ctx.allowsCustomAmount)
                ? (_openBlock(), _createBlock(_component_V1NumericKeypad, {
                    key: 1,
                    class: "v1-other-amount__keypad",
                    "allows-decimals": _ctx.meta.allowsDecimals,
                    "decimal-separator": _ctx.meta.decimalSeparator,
                    "data-testid": "v1-other-amount-keypad",
                    onPress: _ctx.onKeypadPress
                  }, null, 8, ["allows-decimals", "decimal-separator", "onPress"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title", "next-disabled", "onNext"]))
}